import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import * as React from "react";
import * as yup from "yup";
import { applicationInfoType } from "types/app";
import API from "@/api/serverCall";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
// import { useDispatch } from "react-redux";
// import { setApplicationInfoById } from "@/redux/organization/actions";

interface EditDialogBodyProps {
	ApplicationInfo: applicationInfoType[];
	handleModalClose: () => void;
	ApplicationItem: applicationInfoType;
	setApplicationInfo: (value: applicationInfoType[]) => void;
}

type appInfoType = {
	name: string;
};

const EditDialogBody: React.FC<EditDialogBodyProps> = ({
	ApplicationInfo,
	handleModalClose,
	ApplicationItem,
	setApplicationInfo,
}) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	// const dispatch = useDispatch();
	const EditAppFunc = (appInfo: appInfoType) => {
		// loading
		try {
			const requestData = {
				...appInfo,
				id: ApplicationItem.id,
				packageAndroid: "",
				packageIos: "",
			};

			API.PATCH<applicationInfoType>({
				link: `/app`,
				body: requestData,
			}).then((response) => {
				const result = ApplicationInfo.map((v) => {
					return v.id === ApplicationItem.id ? response.data : v;
				});
				setApplicationInfo(result);
				handleModalClose();
				enqueueSnackbar(t("application_change_name.success"), {
					variant: "info",
				});
			});
		} catch (error) {
			console.error(error);
		}
	};

	const validationSchema = yup.object({
		name: yup.string().required(t("application_change_name.guide")),
	});

	const formik = useFormik({
		initialValues: {
			name: ApplicationItem.name,
		},
		validationSchema,
		onSubmit: (values) => {
			EditAppFunc({
				name: values.name,
			});
		},
	});
	return (
		<form onSubmit={formik.handleSubmit}>
			<DialogContent sx={{ padding: "1rem 2rem" }}>
				<div style={{ marginBottom: "3rem" }}>
					<span>{t("application_change_name_input_title")}</span>
					<TextField
						id="name"
						name="name"
						variant="outlined"
						size="medium"
						fullWidth={true}
						value={formik.values.name}
						onChange={formik.handleChange}
						error={formik.touched.name && Boolean(formik.errors.name)}
						helperText={formik.touched.name && formik.errors.name}
					/>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "1rem",
					}}
				>
					<Button
						variant="outlined"
						sx={{
							color: "#747474",
							borderColor: "#747474",
							marginRight: "0.5rem",
						}}
						onClick={handleModalClose}
					>
						{t("application_change_name_cancel")}
					</Button>
					<Button
						variant="contained"
						sx={{ backgroundColor: "#2453F9", color: "white" }}
						type="submit"
					>
						{t("application_change_name_save")}
					</Button>
				</div>
			</DialogContent>
		</form>
	);
};

export default EditDialogBody;
